var __jsx = React.createElement;
import React, { useState } from "react";
import { CopilotKit, useCopilotChat } from "@copilotkit/react-core";
import { CopilotSidebar, useChatContext } from "@copilotkit/react-ui";
import ChatInput from "./ChatInput";
import CustomAssistantMessage from "./CustomAssistantMessage";
import CustomUserMessage from "./CustomUserMessage";
import DraggableModal from "./DraggableModal";
import AwesomeIcon from "../AwesomeIcon";
import { faRobot, faMinus, faPlus, faXmark, faWindowRestore, faWindowMaximize } from "@fortawesome/pro-regular-svg-icons";
import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import { get } from "lodash";
import NewChatModal from "./NewChatModal";
var CopilotWrapper = function CopilotWrapper(_ref) {
  var authData = _ref.authData,
    children = _ref.children;
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        userInfo: s.userInfo
      };
    }),
    userInfo = _useStoreState.userInfo;
  var isEnabled = get(userInfo, ["settings", "ui_settings", "ai_assistant"], false);
  var isLoggedIn = get(authData, ["authenticated"], false);
  if (!isLoggedIn) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement(CopilotKit, {
    runtimeUrl: "/api/copilotkit",
    headers: {
      "x-ai-assistant-enabled": String(isEnabled)
    }
  }, children, /*#__PURE__*/React.createElement(CopilotSidebar, {
    instructions: "You are assisting the user as best as you can. Answer in the best way possible given the data you have.",
    Header: Header,
    Input: function Input(_ref2) {
      var onSend = _ref2.onSend,
        inProgress = _ref2.inProgress,
        isVisible = _ref2.isVisible;
      return /*#__PURE__*/React.createElement(ChatInput, {
        inProgress: inProgress,
        isVisible: isVisible,
        onSend: onSend,
        placeholder: "Ask Qure AI Assistant..."
      });
    },
    Window: DraggableModal,
    AssistantMessage: CustomAssistantMessage,
    UserMessage: CustomUserMessage,
    labels: {
      title: "AI Assistant",
      initial: "Welcome to Qure AI Assistant! I'm your personal assistant for all your needs within the app. I can help you with:\n" + "\n" + "- Adding, Searching, filtering, sharing the patients\n" + "- Retrieving patient summary\n" + "- View the Original or Secondary capture for the patient\n" + "- Editing generated reports\n" + "\n" + "Not sure what I can do? Check out complete list of capabilities from prompts library or simply tell me what you need in your own words."
    },
    className: "fixed bottom-0 right-0 !z-[99]"
  }));
};
var Header = function Header() {
  var _useChatContext = useChatContext(),
    labels = _useChatContext.labels;
  var chat = useCopilotChat();
  var messages = chat.visibleMessages || [];
  var setMessages = chat.setMessages;
  var _useState = useState(false),
    showNewChatModal = _useState[0],
    setShowNewChatModal = _useState[1];
  var _useStoreState2 = useStoreState(Store, function (s) {
      return {
        isDraggableModalMaximized: s.isDraggableModalMaximized
      };
    }),
    isDraggableModalMaximized = _useStoreState2.isDraggableModalMaximized;
  var handleNewChat = function handleNewChat() {
    setShowNewChatModal(true);
  };
  var handleConfirmNewChat = function handleConfirmNewChat() {
    setMessages([]);
    setShowNewChatModal(false);
    trackEvent(MIXPANEL_EVENTS.LLM_MODAL_BUTTONS, {
      button_type: "new_chat",
      action: "click"
    });
  };
  var handleCancelNewChat = function handleCancelNewChat() {
    setShowNewChatModal(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "drag-handle cursor-move mt-1 flex items-center p-4 border-b border-teal-800 text-white shadow-[0_4px_24px_rgba(20,50,100,0.85)]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faRobot,
    size: "lg",
    className: "text-white p-1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ml-3 text-lg"
  }, labels.title)), /*#__PURE__*/React.createElement("div", {
    className: "flex-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end items-center"
  }, messages.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "group flex items-center relative"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mr-2 text-base font-medium text-teal-400 whitespace-nowrap bg-white dark:bg-gray-900 px-3 py-1 rounded shadow-md border border-teal-200 dark:border-teal-700 z-10 transition-all duration-300 opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0"
  }, "New Chat"), /*#__PURE__*/React.createElement("button", {
    onClick: handleNewChat,
    "aria-label": "New Chat",
    title: "New Chat",
    className: "text-white hover:text-gray-200 p-2 transition-all duration-200"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faPlus,
    size: "sm"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "h-6 w-px bg-gray-600 mx-3"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-3"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      Store.update(function (s) {
        s.isDraggableModalMinimized = !s.isDraggableModalMinimized;
      });
      trackEvent(MIXPANEL_EVENTS.LLM_MODAL_BUTTONS, {
        button_type: "minimize",
        action: "click",
        is_minimized: !Store.getRawState().isDraggableModalMinimized
      });
    },
    "aria-label": "Minimize",
    title: "Minimize",
    className: "text-white hover:text-teal-400 p-1 px-2 rounded-full transition-all duration-200 hover:scale-110"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faMinus,
    size: "sm"
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      Store.update(function (s) {
        s.isDraggableModalMaximized = !s.isDraggableModalMaximized;
      });
      trackEvent(MIXPANEL_EVENTS.LLM_MODAL_BUTTONS, {
        button_type: "maximize",
        action: "click",
        is_maximized: !isDraggableModalMaximized
      });
    },
    "aria-label": "Maximize",
    title: "Maximize",
    className: "text-white hover:text-teal-400 p-1 px-2 rounded-full transition-all duration-200 hover:scale-110"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: isDraggableModalMaximized ? faWindowRestore : faWindowMaximize,
    size: "sm"
  })), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      Store.update(function (s) {
        s.isDraggableModalOpen = !s.isDraggableModalOpen;
      });
      trackEvent(MIXPANEL_EVENTS.LLM_MODAL_BUTTONS, {
        button_type: "close",
        action: "click"
      });
    },
    "aria-label": "Close",
    title: "Close",
    className: "text-white hover:text-teal-400  p-1 px-2 rounded-full transition-all duration-200 hover:scale-120"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "sm"
  }))))), /*#__PURE__*/React.createElement(NewChatModal, {
    isOpen: showNewChatModal,
    onConfirm: handleConfirmNewChat,
    onCancel: handleCancelNewChat
  }));
};
export default CopilotWrapper;